<template>
    <div class="d-flex flex-column align-items-center">
        <div class="row">
            <p class="mb-0 text-sm text-secondary text-capitalize font-weight-bold opacity-7">
                ANDAMENTO DA OBRA
            </p>
        </div>
        <template v-if="buildingStatus">
            <div class="row">
                <Knob v-model="buildingStatus.percent" value-template="{value}%" readonly />
            </div>
            <div class="row">
                <p class="mb-0 text-sm text-secondary font-weight-bold opacity-7">
                    {{ buildingStatus.lastUpdate }}
                </p>
            </div>
        </template>
        <template v-else>
            <Skeleton shape="circle" size="6rem"></Skeleton>
            <Skeleton width="7rem" class="mt-2"></Skeleton>
        </template>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Knob from 'primevue/knob';
import axios from 'axios';
import Skeleton from 'primevue/skeleton';

const buildingStatus = ref(null);

const props = defineProps({
    contract: {
        type: Object,
        required: true,
    }
});


onMounted(async () => {
    buildingStatus.value = await fetchData();
});


async function fetchData() {
    try {
        const response = await axios.get(`/enterprises/${props.contract.id_empreendimento}`);
        const data = response.data?.data;
        return {
            lastUpdate: data ? getMonthName(data.LastModifiedDate) : 'Sem atualização recente',
            percent: data ? parseInt(data.AndamentoGeral__c) || 0 : 0
        };
    } catch (error) {
        console.error('Error fetching data:', error);
        return {
            lastUpdate: 'Erro ao buscar dados',
            percent: 0
        };
    } finally {
        //
    }
}

const getMonthName = (dataString, idioma = 'pt-br') => {
    const meses = {
        'pt-br': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        'en-us': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        // Adicione outros idiomas conforme necessário
    };

    const data = new Date(dataString);
    if (isNaN(data)) {
        throw new Error('Formato de data inválido.');
    }

    const indiceMes = data.getMonth();
    const ano = data.getFullYear();
    const nomeMes = meses[idioma.toLowerCase()][indiceMes];
    return `${nomeMes} de ${ano}`;
};

</script>

<style>
.placeholder-glow .placeholder {
    border-radius: 50px;
    cursor: default;
}

.p-knob-value {
    stroke: #4F097B !important;
}

.p-knob-text {
    color: #4F097B !important;
}
</style>
